/**
 * Remove Cart Item Action
 * Triggered by: arc:action:removeCartItem
 */

export const runRemoveCartItem = async (data = {}) => {
    try {
        const { variantKey } = data;
        
        if (!variantKey) {
            throw new Error('Variant key is required');
        }

        // Trigger haptic feedback for removal
        if ('vibrate' in navigator) {
            navigator.vibrate([100, 50, 100]);
        }

        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: variantKey,
                quantity: 0,
            }),
        });

        if (!response.ok) {
            throw new Error('Failed to remove item from cart');
        }

        const updatedCart = await response.json();

        // Dispatch success event
        window.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart: updatedCart, action: 'item_removed' }
        }));

        // Show notification
        // window.dispatchEvent(new CustomEvent('arc:action:showNotification', {
        //     detail: {
        //         message: 'Item removed from cart',
        //         type: 'success',
        //         duration: 3000
        //     }
        // }));

        return {
            success: true,
            cart: updatedCart,
            message: 'Item removed successfully'
        };

    } catch (error) {
        console.error('Remove cart item error:', error);
        return {
            success: false,
            error: error.message
        };
    }
};

export default runRemoveCartItem;
